import { Route } from 'types/route.type';

import ListReports from './list-reports';
import ViewReport from './components/view-report';

export const routes: Route[] = [
  {
    path: '/powerbi/reports',
    component: ListReports,
    id: 'powerBi.navigation.listReports'
  },
  {
    path: '/powerbi/reports/:powerBiReportId',
    component: ViewReport,
  },
];
